
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.225","height":"24.198"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_42466","data-name":"Group 42466","transform":"translate(.75 .75)","fill":"none","stroke":"#5a677c","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_29566","data-name":"Path 29566","d":"M18.006 13.481a2.665 2.665 0 00-2.606 2.675v8.39a.316.316 0 01-.312.312h-4.073a.326.326 0 01-.312-.312V10.02a.315.315 0 01.312-.312h3.991a.308.308 0 01.312.312v1.669h.04a4.619 4.619 0 014.032-2.375h.814a5.182 5.182 0 015.186 5.171v10.046a.318.318 0 01-.312.312h-4.085a.308.308 0 01-.312-.312v-8.418a2.636 2.636 0 00-2.634-2.633z","transform":"translate(-2.667 -2.16)"}}),_c('path',{attrs:{"id":"Path_29567","data-name":"Path 29567","d":"M11.03 10.285v13.643a.746.746 0 01-.746.748h-3.2a.754.754 0 01-.746-.748V10.285a.752.752 0 01.746-.746h3.2a.752.752 0 01.746.746","transform":"translate(-5.968 -1.99)"}}),_c('path',{attrs:{"id":"Path_29568","data-name":"Path 29568","d":"M11.568 7.98a2.7 2.7 0 01-2.715 2.715h-.014a2.728 2.728 0 112.729-2.715","transform":"translate(-6.124 -5.238)"}})])])
          )
        }
      }
    